angular.module('zc')
  .factory('iwGraphOptions', iwGraphOptions);

iwGraphOptions.$inject = ['$filter'];
function iwGraphOptions($filter) {
  return [
    {
      name: 'conversion_rate',
      label: $filter('translate')('projectsIw.graphOptions.conversionRate'),
      unit: ' %',
      decimal: 1
    },
    {
      name: 'cart_button_click_rate',
      label: $filter('translate')('projectsIw.graphOptions.cartButtonClickRate'),
      unit: ' %',
      decimal: 1 },
    {
      name: 'average_item_count',
      label: $filter('translate')('projectsIw.graphOptions.averageItemCount'),
      unit: ' PV',
      decimal: 1
    },
    {
      name: 'average_conversion_price',
      label: $filter('translate')('projectsIw.graphOptions.averageConversionPrice'),
      unit: ' 円',
      decimal: 0
    },
  ];
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_graph_options.constant.js